import { LoginForm } from 'ui/components/company/patterns/LoginForm/LoginForm';

/**
 * 企業系ログインページ
 */
export const CompanyLogin: React.FC = () => {
    return <LoginForm />;
};
